// extracted by mini-css-extract-plugin
export var attachment = "_qi-a";
export var emailContainer = "_qi-4";
export var emailContentPaddedContainer = "_qi-b";
export var emailHeader = "_qi-6";
export var emailIframe = "_qi-3";
export var emailInfoIcon = "_qi-9";
export var emailShortenedSummary = "_qi-e";
export var infoDropdown = "_qi-0";
export var infoRowBoundedContent = "_qi-d";
export var internal = "_qi-5";
export var merchant = "_qi-8";
export var messageInputContainer = "_qi-h";
export var normal = "_qi-7";
export var replyCard = "_qi-f";
export var subtleButton = "_qi-1";
export var subtleButtonIconContainer = "_qi-2";
export var toggleViewRepliesButton = "_qi-c";
export var wrappingText = "_qi-g";